// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "td.shrunk[data-v-49eb4d56]{width:1px}td.nowrap[data-v-49eb4d56],td.shrunk[data-v-49eb4d56]{white-space:nowrap}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
